import React from 'react';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Render from '../Render';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import BrandCard from '../BrandCard';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Autocomplete } from '@mui/material';
import AddIcon from '@mui/icons-material/AddOutlined';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import styles from './FavoriteBrandSearch.module.css';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function FavoriteBrandsSearch(props) {
  const [id, setId] = React.useState(null);
  const [editable, setEditable] = React.useState(false);
  const [numberOfBrands, setNumberOfBrands] = React.useState(5);
  const [favoriteBrandsViewRange, setFavoriteBrandsViewRange] = React.useState([0, 0 + numberOfBrands]);
  const [search, setSearch] = React.useState({ id: '', name: '' });

  React.useEffect(() => {
    if (props.screenWidth >= 1200) {
      setNumberOfBrands(5);
    } else if (props.screenWidth >= 730 && props.screenWidth <= 1199) {
      setNumberOfBrands(3);
    } else if (props.screenWidth >= 535) {
      setNumberOfBrands(2);
    } else {
      setNumberOfBrands(1);
    }
  }, [props.screenWidth]);

  React.useEffect(() => {
    setFavoriteBrandsViewRange([0, 0 + numberOfBrands - 1]);
  }, [numberOfBrands]);

  React.useEffect(() => {
    if ((props.deleteMeta.success && props.favoriteBrands.length <= 5)) {
      setFavoriteBrandsViewRange([0, 0 + numberOfBrands - 1]);
    }
  }, [props.deleteMeta.success, props.favoriteBrands]);

  React.useEffect(() => {
    if (search.id != '') {
      setId(search.id);
    }
  }, [search]);

  React.useEffect(() => {
    if (props.updateAccountBrands.success) {
      props.handleClose();
    }
  }, [props.updateAccountBrands.success]);

  function showNextGroupOfFavoriteBrandsItems(direction: string) {
    if (direction == 'up' && favoriteBrandsViewRange[1] !== props.favoriteBrands.length - 1) {
      setFavoriteBrandsViewRange([favoriteBrandsViewRange[0] + numberOfBrands, favoriteBrandsViewRange[1] + numberOfBrands]);
    } else if (direction == 'down' && favoriteBrandsViewRange[0] !== 0) {
      setFavoriteBrandsViewRange([favoriteBrandsViewRange[0] - numberOfBrands, favoriteBrandsViewRange[1] - numberOfBrands]);
    }

    if (direction == 'up' && favoriteBrandsViewRange[1] >= props.favoriteBrands.length - 1) {
      setFavoriteBrandsViewRange([0, 0 + numberOfBrands - 1]);
    } else if (direction == 'down' && favoriteBrandsViewRange[0] <= 0) {
      setFavoriteBrandsViewRange([props.favoriteBrands.length - 5, props.favoriteBrands.length - 5 + numberOfBrands - 1]);
    }
  }

  function toggleEditable() {
    setEditable(!editable);
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.inner_container}>
          <h2 className={styles.title}>
            Shop By Your Favorite Brands
          </h2>
          <Render if={props.loggedIn}>
            <IconButton
              aria-label="edit favorite brands"
              className={styles.editIcon}
              onClick={toggleEditable}
            >
              <EditIcon fontSize="inherit" />
            </IconButton>
          </Render>
        </div>
      </div>
      <div style={props.favoriteBrands.length > 5 ? { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: 215 } : 
      { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', height: 215 }}>
        <Render if={props.favoriteBrands.length > numberOfBrands}>
          <ArrowBack className={styles.arrows} onClick={() => showNextGroupOfFavoriteBrandsItems('down')} />
        </Render>
        <Render if={props.favoriteBrands.length == 0 && !props.loggedIn}>
          <h2 className={styles.label}>Log In And Add Your Favorite Brands Here For Easy Access!</h2>
        </Render>
        <Render if={props.favoriteBrands.length == 0 && props.loggedIn}>
          <h2 className={styles.label}>Add Your Favorite Brands Here For Easy Access!</h2>
        </Render>
        {props.favoriteBrands.map((favorite, index) => {
          if (index >= favoriteBrandsViewRange[0] && index <= favoriteBrandsViewRange[1]) {
            return (
              <BrandCard
                favorite={favorite}
                index={index}
                deleted={props.deleted}
                editable={editable}
              />
            )
          }
        })}
        <Render if={editable}>
          <Button
            onClick={props.handleClickOpen}
            className={styles.addButton}
            variant='outlined'
          >
            <AddIcon className={styles.addIcon} />
          </Button>
        </Render>
        <BootstrapDialog
          onClose={props.handleClose}
          open={props.open}
        >
          <DialogTitle sx={{ m: 0, p: 2 }}>
            Select Brand
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={props.handleClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              width: 7,
              height: 7,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <div className={styles.dropdown}>
              <BrandDropdown 
                search={search}
                setSearch={setSearch}
                brands={props.brands}
              />
            </div>
            <div>
              {props.showErrorMessage &&
                <Typography
                  variant='body1'
                  className={styles.error}>
                  {props.updateAccountBrandsMeta.message}
                </Typography>
              }
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={(e) => props.submit(e, id)}>
              Add Brand
            </Button>
          </DialogActions>
        </BootstrapDialog>
        <Render if={props.favoriteBrands.length > numberOfBrands}>
          <ArrowForward className={styles.arrows} onClick={() => showNextGroupOfFavoriteBrandsItems('up')} />
        </Render>
      </div>
    </>
  );
}
export default FavoriteBrandsSearch;

function BrandDropdown(props) {

  function renderBrandOption(props, brand) {
    return (
      <MenuItem 
        {...props} 
        key={brand.id} 
        dense 
        disableGutters
        sx={{ fontSize: 12 }}
        value={brand.id}
      >
        {brand.name}
      </MenuItem>
    );
  }
  
  function getBrandLabel(option) {
    if (option.name) {
      return option.name;
    } else {
      return '';
    }
  }

  return (
    <div className={styles.input_container}>
      <Autocomplete 
        options={props.brands.length > 0 ? props.brands : []}
        value={props.search.brand}
        fullWidth
        renderInput={(params) => (
          <div ref={params.InputProps.ref}>
            <input
              {...params.inputProps} 
              placeholder="Select Brand"
              className={styles.input}
              type='text'
            />
          </div>
        )}
        renderOption={renderBrandOption}
        getOptionLabel={getBrandLabel}
        onChange={(e, brand) => props.setSearch({ id: brand?.id, name: brand?.name })}
      />
    </div>
  );
}